import { create } from "zustand";

export type DayPriceMap = Record<string, number>;

export const useDayPriceStore = create<{
  /** Prices keyed by date string (YYYY-MM-DD) */
  dayPrices: DayPriceMap;
  setDayPrices: (prices: DayPriceMap) => void;
}>((set) => ({
  dayPrices: {},
  setDayPrices: (prices) => set({ dayPrices: prices }),
}));
